export default function readmore() {
    const readmores = document.querySelectorAll('[data-readmore]');
    console.log('Found readmores: ', readmores.length);
    readmores.forEach(readmore => {
        readmore.classList.add('spv-readmore', 'spv-readmore--hide');
        const maxNum = parseInt(readmore.dataset.readmore || '3');
        const children = Array.from(readmore.children);
        if (children.length <= maxNum) {
            return;
        }
        const readmoreButton = document.createElement('button');
        readmoreButton.innerHTML = `Se ${children.length - maxNum} flere`;
        readmoreButton.setAttribute('aria-hidden', 'true');
        readmoreButton.setAttribute('tabindex', '-1');
        children.forEach((child, index) => {
            if (index >= maxNum) {
                child.classList.add('spv-readmore__hidden');
                child.getElementsByTagName('a')[0]?.addEventListener('focus', () => {
                    child.classList.remove('spv-readmore__hidden');
                    const hiddenCount = readmore.getElementsByClassName('spv-readmore__hidden').length;
                    readmoreButton.innerHTML = `Se ${hiddenCount} flere`;
                    if (hiddenCount <= 0) {
                        readmoreButton.remove();
                    }
                });
            }
        });
        readmoreButton.classList.add('spv-readmore__button', 'spv-button', 'spv-button--pill', 'spv-button--primary', 'spv-colSpan--full');
        readmoreButton.addEventListener('click', () => {
            readmore.classList.remove('spv-readmore--hide');
            children.forEach(child => {
                child.classList.remove('spv-readmore__hidden');
            });
            readmoreButton.remove();
        });
        readmore.after(readmoreButton);
    });
}
window.addEventListener('DOMContentLoaded', () => {
    readmore();
});
//# sourceMappingURL=readmore.js.map